import { ButtonGroup, ButtonText, Dialog, DialogCardBody, DialogCardFooter, DialogCardHead, DialogCardHeadTitle, Select, Typography } from "@visa/vds"
import { IMPLEMENTATION_TYPE_PRODUCTS, PACKAGE_TYPE } from "_constants/CertificationTestingConstants";
import { CERTIFICATION_PACKAGES_INFO_WITH_ID } from "_constants/PageRoutes";
import { DateHelper } from "_helpers/DateHelper";
import MCSSpace from "components/MCSSpace";
import { AuthContext } from "context/AuthContext";
import React, { useContext, useEffect, useState } from "react"
import { trackPromise } from "react-promise-tracker";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ceritificationPackageService } from "services/certification.certificationPackage";
import "./CertificationPackage.css"
import { GlobalAlertContext } from "context/GlobalAlertContext";

const NewCertificationPackage = (props) => {

    const userData = useContext(AuthContext);
    const bid = userData.user.organization.bid
    const history = useHistory();
    const alertContext = useContext(GlobalAlertContext);
    let [packageType, setPackageType] = useState(PACKAGE_TYPE.NEW);
    let [selectedPackage, setSelectedPackage] = useState(null)
    let [packages, setPackages] = useState([])

    let { open, setOpen, } = props

    const createNewPackage = async () => {
        await createPackageHelper(() => ceritificationPackageService.CreateNewCertificationPackage(bid))
    }

    const createReopenPackage = async () => {
        await createPackageHelper(() => ceritificationPackageService.CreateReopenCertificationPackage(bid, selectedPackage.id))
    }

    const createPackageHelper = async (createApi) => {
        trackPromise(
            createApi()
                .then((response) => {
                    if (response.status === 200) {
                        let newPackageId = response.data.result
                        alertContext.setSuccessMessage(`Successfully created package: ${newPackageId}`)
                        history.push({
                            pathname: CERTIFICATION_PACKAGES_INFO_WITH_ID(newPackageId),
                        })
                    } else {
                        alertContext.setErrorMessage("Error creating new package")
                    }
                })
                .catch((error) => alertContext.setErrorMessage(error.response.data.result.message))
        )
    }

    const fetchData = async () => {
        trackPromise(
            ceritificationPackageService.GetValidCompletedCertificationPackages(bid)
                .then((response) => {
                    const packages = response.data.result
                    if (response.status === 200 && packages) {
                        setPackages(packages)
                        setSelectedPackage(packages[0])
                    }
                })
                .catch((error) => alertContext.setErrorMessage("Error getting valid completed Certification Packages"))
        )
    };

    useEffect(() => {
        if (packageType == PACKAGE_TYPE.REOPEN) fetchData()
    }, [packageType]);
    return (
        <>
            <Dialog
                className="new-certification-dialog"
                aria-labelledby="new-certification-dialog"
                aria-describedby="new-certification-dialog"
                onExit={(e) => {e.stopPropagation(); setOpen(false)}}
                open={open}
            >
                <DialogCardHead>
                    <DialogCardHeadTitle className="visa-blue" id="new-certification-dialog-title">Create Certification Package</DialogCardHeadTitle>
                </DialogCardHead>
                <DialogCardBody id="dialog-description-example-1">
                    <Select
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        onChange={(e) => {
                            setPackageType(e.target.value)
                        }}
                        label="Package Type*" defaultValue={PACKAGE_TYPE.NEW}
                        value={packageType}
                    >
                        <option value={PACKAGE_TYPE.NEW}>New</option>
                        <option value={PACKAGE_TYPE.REOPEN}>Reopen</option>
                    </Select>

                    {
                        packageType == PACKAGE_TYPE.NEW
                            ? <></>
                            : packageType == PACKAGE_TYPE.REOPEN && packages && selectedPackage
                                ?
                                <>
                                    <Select
                                        onClick={(e) => {
                                            e.stopPropagation();
                                        }}
                                        onChange={(e) => {
                                            setSelectedPackage(packages.find(x => x.id == e.target.value))
                                        }}
                                        label="Select Previous Certification Package ID*" defaultValue={selectedPackage.id}
                                        value={selectedPackage.id}
                                    >
                                        {packages.map((currPackage, idx) => <option value={currPackage.id}>{`${currPackage.id} - ${currPackage.packageName}`}</option>)}
                                    </Select>

                                    <MCSSpace height={15} />

                                    <Typography>Component: {<b>{selectedPackage.component === IMPLEMENTATION_TYPE_PRODUCTS.ACS ? "ACS" : "3DS"}</b>}</Typography>
                                    <Typography>ImplementationType: {<b>{selectedPackage.implementationType}</b>}</Typography>
                                    <Typography>Protocol Version: {<b>{selectedPackage.protocolVersion}</b>}</Typography>
                                    <Typography>Visa Secure Compliance Letter: {<b>{selectedPackage.compApprovalId}</b>}</Typography>
                                    <Typography>Visa Secure Compliance Letter Issue Date: {<b>{DateHelper.ToFormattedDate(selectedPackage.compIssueDate)}</b>}</Typography>

                                </>
                                :
                                <Typography>No previous certification packages found.</Typography>
                    }
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        <ButtonText colorScheme="secondary" onClick={(e) => {
                            e.stopPropagation();
                            setPackageType(PACKAGE_TYPE.NEW)
                            setOpen(false)
                        }}>
                            Cancel
                        </ButtonText>
                        <ButtonText disabled={packageType == PACKAGE_TYPE.REOPEN && !selectedPackage} colorScheme="primary"
                            onClick={(e) => {
                                e.stopPropagation();
                                packageType == PACKAGE_TYPE.NEW ? createNewPackage() : createReopenPackage()
                            }}
                        >
                            Create
                        </ButtonText>
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    )
}

export default NewCertificationPackage